import { ProductHatProps } from '@wix/package-picker-components';
import { useTranslation } from 'react-i18next';

export const useHatProperties = ({
  isRecommended,
  isCurrentPlan,
  isOnSale,
  text,
}: {
  isRecommended?: boolean;
  isCurrentPlan?: boolean;
  isOnSale?: boolean;
  text?: string;
}): ProductHatProps | undefined => {
  const { t } = useTranslation();
  let hatProperties: ProductHatProps | undefined;

  if (isRecommended) {
    hatProperties = {
      hatText: t(text || 'RECOMMENDED').toUpperCase(),
      background: '#A6FFD7',
    };
  }
  if (isOnSale) {
    hatProperties = {
      hatText: t('premium-purchase-plan.cards.hat_sale', '50% OFF'),
      background: '#DEFF00',
    };
  }
  if (isCurrentPlan) {
    hatProperties = {
      hatText: t(
        'premium-purchase-plan.cards.hat.current_plan',
        'CURRENT PLAN',
      ),
      background: '#EBEBEB',
      textWhite: false,
    };
  }
  return hatProperties;
};
